// @ts-nocheck
import { Platform, NativeModules } from 'react-native';

const _InCallManager = NativeModules.InCallManager;

class NativeAudioManager {
  constructor() {
    this.vibrate = false;
  }

  start(setup) {
    setup = setup === undefined ? {} : setup;
    const media = setup.media === 'video' ? 'video' : 'audio';
    _InCallManager.start();
    if (media === 'audio') _InCallManager.setVoiceCallMode();
  }

  stop() {
    Platform.OS === 'android' ? _InCallManager.stop() : _InCallManager.stop({});
  }

  async getIsWiredHeadsetPluggedIn() {
    try {
      return await _InCallManager.getIsWiredHeadsetPluggedIn();
    } catch (e) {
      return {};
    }
  }

  async isBluetoothHeadsetConnected() {
    try {
      return await _InCallManager.isBluetoothHeadsetConnected();
    } catch (e) {
      return {};
    }
  }

  setKeepScreenOn(enable) {
    enable = enable === true;
    _InCallManager.setKeepScreenOn(enable);
  }

  setSpeakerphoneOn(enable) {
    enable = enable === true;
    _InCallManager.setSpeakerphoneOn(enable);
  }

  setForceSpeakerphoneOn(_flag) {
    const flag = typeof _flag === 'boolean' ? (_flag ? 1 : -1) : 0;
    _InCallManager.setForceSpeakerphoneOn(flag);
  }

  setMicrophoneMute(enable) {
    enable = enable === true;
    _InCallManager.setMicrophoneMute(enable);
  }

  async chooseAudioRoute(route: String) {
    return await _InCallManager.chooseAudioRoute(route);
  }

  async requestAudioFocus() {
    if (Platform.OS === 'android') {
      return await _InCallManager.requestAudioFocusJS();
    }
  }

  async abandonAudioFocus() {
    if (Platform.OS === 'android') {
      return await _InCallManager.abandonAudioFocusJS();
    }
  }

  forceUpdateAudioDevices() {
    if (Platform.OS === 'ios') {
      _InCallManager.forceUpdateAudioDevices();
    }
  }

  async getCurrentAudioDevice() {
    try {
      const result = await _InCallManager.getCurrentAudioDevice();

      if (Platform.OS === 'android' && result && result.currentDevice) {
        // Map Android device names to lowercase format
        const deviceMap = {
          SPEAKER_PHONE: 'speaker',
          BLUETOOTH: 'bluetooth',
          WIRED_HEADSET: 'wired',
          EARPIECE: 'earpiece',
          NONE: null,
        };
        return deviceMap[result.currentDevice] || null;
      }

      // iOS returns string directly
      return result || null;
    } catch (_err) {
      return null;
    }
  }
}

export default new NativeAudioManager();
